import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import TokenService from '../../services/autentication/token.service';
import { InputText } from 'primereact/inputtext';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import { RadioButton } from 'primereact/radiobutton';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import SalesOrderingService from '../../services/sales-ordering/sales-ordering-service';
import { captureInvoiceLocation } from '../../services/invoices/invoice-location.service';
import orderServices from '../../services/orders/orderservice';
import { calculateTotalTax, calculateItemSum, calculateItemTotal } from '../products/product-calculation';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputSwitch } from 'primereact/inputswitch';
import Helpers from '../../utils/helpers';

import {
    UserDTO,
    UserAddressDTO,
    CourierProviderDTO,
    CartItem,
    SalesOrderingDialogProps,
    ViewMode,
    UserOption
} from '../../models/sales-ordering/sales-ordering-model';
import { ProductNewModel } from '../../models/products/product-new-model';
import { ProductCheckoutModel } from '../../models/products/product-checkout-model';
import ProductCardItems from '../products/products-card-items';
//import './sales-ordering.css';
import { Message } from 'primereact/message';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import UserAddressService from '../../services/useraddress/useraddress.service';
import SalesOrderingCustomer from './sales-ordering-customer';
import SalesOrderingAddress from './sales-ordering-address';

import AuthService from '../../services/autentication/auth.service';
import OrderService from '../../services/order/order.service';
import UserService from '../../services/user/user.service';
import { useSalesDelivery } from './use-sales-delivery';
import { salesAvailableQuantity, salesProduct, salesStockError, salesStockLocationLabel } from '../../services/sales-ordering/sales-delivery.service';
import SalesCartStock from './sales-cart-stock';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { selectedGetway } from '../../redux/slices/getway-link';
import { GetWayLinkModel } from '../../models/getway-link/getway-link-model';
import RouteConstant from '../../constants/route.constants';

import SalesOrderingPayment from './sales-ordering-payment';
import SalesOrderingPaymentMode from './sales-ordering-payment-mode';
import OrderPrint from '../New-Invoice-Report/new-order-print';
import NewOrderReview from '../New-Invoice-Report/new-order-review';
import ProductQuickView from '../products/product-quick-view';

import { Suspense } from 'react';

const PaymentConfirmDialog = React.lazy(() => import('../orders/payment-details-dialog'));
const UserSwipeMachineDialog = React.lazy(() => import('../SwipeMachine-UserAccess/userSwipeMachineDialog'));

const { Html5Qrcode } = require('html5-qrcode');


const SalesOrderingDialog: React.FC<SalesOrderingDialogProps> = ({ visible, onHide, toast }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [placingOrder, setPlacingOrder] = useState(false);
    const [viewMode, setViewMode] = useState<ViewMode>('CATALOG');
    const [viewAllProducts, setViewAllProducts] = useState(false);
    const [isSelfPickup, setIsSelfPickup] = useState(false);
    const [isPosMapped, setIsPosMapped] = useState(false);
    useEffect(() => {
        let active = true;
        setIsPosMapped(false);
        if (visible) {
            UserService.getCurrentUser().then(user => {
                if (active) setIsPosMapped(user?.isPosMapped === true);
            }).catch(() => {
                if (active) setIsPosMapped(false);
            });
        }
        return () => { active = false; };
    }, [visible]);

    const [selectedBatches, setSelectedBatches] = useState<Record<number, any>>({});
    const [checkoutOpen, setCheckoutOpen] = useState(false);
    const [showAddUserForm, setShowAddUserForm] = useState(false);

    // Swipe Machine state
    const isAdmin = useAppSelector((state) => state.isAdmin);
    const [isConfirmDialog, setIsConfirmDialog] = useState(false);
    const [showMachineDialog, setShowMachineDialog] = useState(false);
    const [orderIdNum, setOrderIdNum] = useState<number>(0);
    const [plutusRefId, setPlutusRefId] = useState<number>(0);

    const [showAddressConfirmDialog, setShowAddressConfirmDialog] = useState(false);
    const [showAddAddressForm, setShowAddAddressForm] = useState(false);
    const [createdUserId, setCreatedUserId] = useState<number | null>(null);

    const [products, setProducts] = useState<ProductNewModel[]>([]);
    const [productsLoading, setProductsLoading] = useState(false);
    const [customerLoading, setCustomerLoading] = useState(false);
    const [courierProviders, setCourierProviders] = useState<CourierProviderDTO[]>([]);

    const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
    const [selectedUser, setSelectedUser] = useState<UserDTO | null>(null);

    const [userAddresses, setUserAddresses] = useState<UserAddressDTO[]>([]);
    const [selectedAddress, setSelectedAddress] = useState<UserAddressDTO | null>(null);

    const [deliveryMethod, setDeliveryMethod] = useState<'HOME_DELIVERY' | 'COURIER'>('HOME_DELIVERY');
    const [selectedCourierId, setSelectedCourierId] = useState<number | null>(null);

    const [paymentMethod, setPaymentMethod] = useState<'CASH' | 'ONLINE' | 'UPI' | 'CARD'>('CASH');
    const [selectedPaymentObj, setSelectedPaymentObj] = useState<any>(null);
    const [checkoutStep, setCheckoutStep] = useState<'CART_DELIVERY' | 'PAYMENT'>('CART_DELIVERY');
    const [orderSuccess, setOrderSuccess] = useState<{ visible: boolean, orderId: string, amount: number, date: string, deliveryDate: string }>({ visible: false, orderId: '', amount: 0, date: '', deliveryDate: '' });

    const [cart, setCart] = useState<Map<number, CartItem>>(new Map());
    const deliveryStock = useSalesDelivery(visible, String(TokenService.getUser()?.userID ?? ''), {
        userId: selectedUserId, userAddressId: selectedAddress?.addressId ?? 0, isSelfPickup
    }, Array.from(cart.values()).map(item => ({ id: item.id, quantity: item.quantity })));
    const availabilityRef = useRef(deliveryStock); availabilityRef.current = deliveryStock;
    const checkoutBlocked = deliveryStock.blocked || customerLoading;
    const availableProducts = useMemo(() => products.map(product => salesProduct(product, deliveryStock.data)), [products, deliveryStock.data]);
    const cannotIncrease = (item: CartItem) => {
        const available = salesAvailableQuantity(item.id, deliveryStock.data);
        const step = Number(item.orderMultiples) > 0 ? Number(item.orderMultiples) : 1;
        return !deliveryStock.data || (available !== null && Number((item.quantity + step).toFixed(4)) > available);
    };
    const activePosId = isSelfPickup ? deliveryStock.data?.posId ?? null : null;
    const submission = useRef(false);
    const requestVersion = JSON.stringify([deliveryStock.key, selectedBatches, selectedPaymentObj?.id, deliveryMethod, selectedCourierId]);
    const currentRequest = useRef(requestVersion); currentRequest.current = requestVersion;
    useEffect(() => { setSelectedBatches({}); setCheckoutStep('CART_DELIVERY'); }, [isSelfPickup, activePosId, selectedUserId, selectedAddress?.addressId]);
    const proceedToPayment = async () => {
        if (customerLoading) return;
        try { await deliveryStock.verify(); setCheckoutStep('PAYMENT'); }
        catch (error) { toast.current?.show({ severity: 'warn', summary: 'Review stock', detail: salesStockError(error) }); }
    };
    const [editingItemId, setEditingItemId] = useState<number | null>(null);
    const [editingValueStr, setEditingValueStr] = useState<string>("");

    const [productSearch, setProductSearch] = useState('');
    const deliverySectionRef = useRef<HTMLDivElement>(null);
    const courierTableRef = useRef<HTMLDivElement>(null);
    const deliverySectionRefMobile = useRef<HTMLDivElement>(null);
    const courierTableRefMobile = useRef<HTMLDivElement>(null);
    const prevIsSelfPickup = useRef(isSelfPickup);

    // ── Scanner state ──────────────────────────────────────────────────────────
    const [scannerOpen, setScannerOpen] = useState(false);
    const [scanInput, setScanInput] = useState('');
    const [scanLoading, setScanLoading] = useState(false);
    const [scanPickerProducts, setScanPickerProducts] = useState<ProductNewModel[]>([]);
    const [scanPickerOpen, setScanPickerOpen] = useState(false);
    const scanInputRef = useRef<HTMLInputElement>(null);
    const scanSubmitRef = useRef<(code: string) => Promise<void>>(async () => {});
    const [cameraActive, setCameraActive] = useState(false);
    const html5QrRef = useRef<any>(null);
    const [scanPickerSelected, setScanPickerSelected] = useState<Set<number>>(new Set());
    // ──────────────────────────────────────────────────────────────────────────

    // ── Quick View state ───────────────────────────────────────────────────────
    const [quickViewProduct, setQuickViewProduct] = useState<ProductNewModel | null>(null);
    const [quickViewVisible, setQuickViewVisible] = useState(false);
    // ──────────────────────────────────────────────────────────────────────────

    const [visibleOrderDetail, setVisibleOrderDetail] = useState(false);
    const [detailsOrder, setDetailsOrder] = useState<any>(null);

    // Reward points for Sales Ordering
    const [availableRewardPoints, setAvailableRewardPoints] = useState(0);
    const [rewardToCurrencyRatio, setRewardToCurrencyRatio] = useState(0);
    const [useRewards, setUseRewards] = useState(true);
    const [rewardsPointsRedeemed, setRewardsPointsRedeemed] = useState(0);



    useEffect(() => {
        const dialogContent = document.querySelector('.sales-ordering-dialog .p-dialog-content') as HTMLElement;
        const preventScroll = (e: Event) => {
            const target = e.target as HTMLElement;
            if (target && (target.classList.contains('p-dialog-content') || target.classList.contains('sales-layout-container'))) {
                if (target.scrollTop > 0) {
                    target.scrollTop = 0;
                }
            }
        };

        if (visible) {
            loadCourierProviders();
            if (dialogContent) {
                dialogContent.addEventListener('scroll', preventScroll, true);
            }
        } else {
            resetState();
            if (dialogContent) {
                dialogContent.removeEventListener('scroll', preventScroll, true);
            }
        }

        return () => {
            if (dialogContent) {
                dialogContent.removeEventListener('scroll', preventScroll, true);
            }
        };
    }, [visible]);






    useEffect(() => {
        if (selectedAddress?.state && cart.size > 0) {
            loadCourierProviders();
        }
        setTimeout(() => {
            const layoutContainer = document.querySelector('.sales-layout-container');
            if (layoutContainer && layoutContainer.scrollTop > 0) {
                layoutContainer.scrollTop = 0;
            }
            const dialogContent = document.querySelector('.sales-ordering-dialog .p-dialog-content');
            if (dialogContent && dialogContent.scrollTop > 0) {
                dialogContent.scrollTop = 0;
            }
        }, 50);
    }, [selectedAddress, cart]);

    useEffect(() => {
        if (selectedAddress && cart.size > 0) {
            const homeAvailable = isHomeDeliveryAvailable();
            const courierAvailable = isCourierDeliveryAllowed();

            if (homeAvailable) {
                setDeliveryMethod('HOME_DELIVERY');
            }
            else if (courierAvailable) {
                setDeliveryMethod('COURIER');
            }
        }
    }, [selectedAddress, cart]);




    const resetState = () => {
        setCart(new Map());
        setSelectedUserId(null);
        setSelectedUser(null);
        setSelectedAddress(null);
        setDeliveryMethod('HOME_DELIVERY');
        setPaymentMethod('CASH');
        setIsSelfPickup(false);
        setViewMode('CATALOG');
        setUserAddresses([]);
        setSelectedCourierId(null);
        setProductSearch('');
        setCheckoutOpen(false);
        setShowAddUserForm(false);
        setCreatedUserId(null);
        setShowAddAddressForm(false);
        setCheckoutStep('CART_DELIVERY');
        setOrderSuccess({ visible: false, orderId: '', amount: 0, date: '', deliveryDate: '' });
        setSelectedPaymentObj(null);
        // Scanner reset
        closeScannerCamera();
        setScannerOpen(false);
        setScanInput('');
        setScanPickerProducts([]);
        setScanPickerOpen(false);
        setScanPickerSelected(new Set());
        setSelectedBatches({});
    };

    const handlePlaceOrder = async () => {
        if (submission.current || customerLoading) return;
        if (isSelfPickup && checkoutStep !== 'PAYMENT') { await proceedToPayment(); return; }
        if (!selectedUser) {
            toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Please select a user' });
            return;
        }
        if (!isSelfPickup && !selectedAddress) {
            toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Please select an address' });
            return;
        }

        const isZeroTotal = totals.total <= 0;
        if (!isZeroTotal && !selectedPaymentObj) {
            toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Please select a payment method' });
            return;
        }

        submission.current = true;
        const before = requestVersion;
        const invoiceActor = TokenService.getUser()?.userID;
        setLoading(true);
        setPlacingOrder(true);
        try {
            // Delivery orders are invoiced later; pickup creates an invoice in this request.
            const invoiceCreationLocation = isSelfPickup ? await captureInvoiceLocation() : undefined;
            await deliveryStock.verify();
            if (currentRequest.current !== before) throw new Error('The order selection changed. Review it and retry.');
            if (isSelfPickup && (!activePosId || cartItemsList.some(item => {
                const allocations = selectedBatches[item.id] as Array<{ batchId: number; quantity: number }> | undefined;
                return !allocations?.length || allocations.some(a => !a.batchId || !Number.isFinite(a.quantity) || a.quantity <= 0) ||
                    Math.abs(allocations.reduce((sum, a) => sum + a.quantity, 0) - item.quantity) > 0.000001;
            }))) throw new Error('Allocate the full quantity of every pickup item to available batches before placing the order.');
            // Build payload for SalesOrderingService (CreateSalesOrderMainDTO)
            // This endpoint correctly handles IsSelfPickUp — address is not required for self-pickup
            const paymentModeID = isZeroTotal ? 10 : Number(selectedPaymentObj?.id);
            const salesPayload = {
                invoiceCreationLocation,
                userID: selectedUserId,
                isSelfPickUp: isSelfPickup,
                posId: isSelfPickup ? activePosId : null,
                userAddressID: isSelfPickup ? 0 : (selectedAddress ? selectedAddress.addressId : 0),
                taxableAmount: totals.subtotal,
                taxAmount: totals.tax,
                discountAmount: 0,
                grossAmount: totals.total,
                comment: '',
                paymentModeID: paymentModeID,
                courierProviderID: deliveryMethod === 'COURIER' ? (selectedCourierId || null) : null,
                courierCharges: deliveryMethod === 'COURIER' ? totals.delivery : 0,
                packingCharges: 0,
                handlingCharges: 0,
                paymentGatewayCharges: 0,
                rewardPointsUsed: rewardsPointsRedeemed,
                rewardToCurrencyRatio: rewardToCurrencyRatio,
                rewardDiscountAmount: useRewards ? (rewardsPointsRedeemed * rewardToCurrencyRatio) : 0,
                orderDetail: cartItemsList.flatMap((item: any) => {
                    const allocations = isSelfPickup ? selectedBatches[item.id] || [] : [];
                    if (allocations.length === 0) {
                        return [{
                            productID: item.id,
                            unitPrice: item.unitPrice,
                            quantity: item.quantity,
                            taxableAmount: calculateItemSum(item.unitPrice, item.quantity),
                            taxAmount: calculateTotalTax(item.unitPrice, item.quantity, item.tax),
                            discountAmount: 0,
                            courierDocketNbr: '',
                            batchId: null,
                            grossAmount: calculateItemTotal(
                                item.unitPrice,
                                item.quantity,
                                calculateTotalTax(item.unitPrice, item.quantity, item.tax),
                                0
                            )
                        }];
                    }

                    return allocations.map((alloc: any) => ({
                        productID: item.id,
                        unitPrice: item.unitPrice,
                        quantity: alloc.quantity,
                        taxableAmount: calculateItemSum(item.unitPrice, alloc.quantity),
                        taxAmount: calculateTotalTax(item.unitPrice, alloc.quantity, item.tax),
                        discountAmount: 0,
                        courierDocketNbr: '',
                        batchId: alloc.batchId,
                        grossAmount: calculateItemTotal(
                            item.unitPrice,
                            alloc.quantity,
                            calculateTotalTax(item.unitPrice, alloc.quantity, item.tax),
                            0
                        )
                    }));
                })
            };

            if (!isZeroTotal && ["CARD", "UPI"].includes(selectedPaymentObj?.mode?.toUpperCase())) {
                let eligibility = await OrderService.checkCardAndUpiEligibility();
                if (!eligibility.isSuccess && selectedUserId) {
                    eligibility = await OrderService.checkCardAndUpiEligibility(selectedUserId);
                }
                if (!eligibility.isSuccess) {
                    setShowMachineDialog(true);
                    setLoading(false);
                    return;
                }
            }

            if (currentRequest.current !== before) throw new Error('The order selection changed. Review it and retry.');
            if (invoiceActor !== TokenService.getUser()?.userID) throw new Error('Your session changed. Review the order and retry.');
            const response = await SalesOrderingService.createOrderBySales(salesPayload);

            if (response && (response.isSuccess || response.id > 0)) {
                const paymentId = isZeroTotal ? 10 : Number(selectedPaymentObj?.id);
                const isSwipeMachine = !isZeroTotal && ["CARD", "UPI"].includes(selectedPaymentObj?.mode?.toUpperCase());

                if (isSwipeMachine && response.plutusTransactionReferenceID) {
                    setOrderIdNum(Number(response.id));
                    setPlutusRefId(Number(response.plutusTransactionReferenceID));
                    setIsConfirmDialog(true);
                    setCheckoutOpen(false);
                    setLoading(false);
                    return;
                }

                // Online payment modes — redirect to payment gateway
                const onlinePaymentModes = [5, 7, 9];
                if (paymentId !== 10 && onlinePaymentModes.includes(paymentId) && response.additionalInfo?.paymentURL) {
                    const getwayData: GetWayLinkModel = {
                        paymentURL: response.additionalInfo.paymentURL,
                        expectedDeliveryDate: response.additionalInfo.expectedDeliveryDate,
                    };
                    dispatch(selectedGetway(getwayData));
                    navigate(RouteConstant.getwayProcess);
                    return;
                }
                setOrderSuccess({
                    visible: true,
                    orderId: response.id ? response.id.toString() : 'NA',
                    amount: totals.total,
                    date: Helpers.formatDateWithShortMonthSpaced(new Date()),
                    deliveryDate: response.additionalInfo?.expectedDeliveryDate
                        || Helpers.formatDateWithShortMonthSpaced(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))
                });

                // Auto-refresh rewards balance
                window.dispatchEvent(new CustomEvent('refresh-rewards'));
                if (selectedUserId) {
                    OrderService.getUserRewardBalance(selectedUserId).then(res => {
                        setAvailableRewardPoints(res?.availablePoints ?? 0);
                    });
                }
            } else if (response?.message?.toLowerCase().includes("swipe machine")) {
                setShowMachineDialog(true);
            } else {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: response?.message || 'Order Failed' });
            }

        } catch (e: any) {
            console.error('Sales order submission failed.');
            toast.current?.show({ severity: 'error', summary: 'Error', detail: e.message || 'Failed to place order' });
        } finally {
            setLoading(false);
            setPlacingOrder(false);
            submission.current = false;
        }
    };

    const handleViewOrderDetail = async (orderId: number) => {
        try {
            setLoading(true);
            const details = await orderServices.GetOrderByOrderId(orderId);
            if (details) {
                setDetailsOrder(details);
                setVisibleOrderDetail(true);
            } else {
                toast.current?.show({ severity: 'warn', summary: 'Warning', detail: 'No details found for this order' });
            }
        } catch (error) {
            console.error("Error while fetching order details:", error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch order details' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let active = true;
        setUserAddresses([]); setSelectedAddress(null);
        const loadAddressesAndRewards = async () => {
            if (selectedUserId) {
                setCustomerLoading(true);
                try {
                    // Load addresses
                    const addresses = await SalesOrderingService.getUserAddresses(selectedUserId);
                    if (!active) return;
                    setUserAddresses(addresses);
                    if (addresses.length > 0) {
                        setSelectedAddress(addresses[0]);
                    }

                    // Load rewards
                    const res = await OrderService.getUserRewardBalance(selectedUserId);
                    if (!active) return;
                    const points = res?.availablePoints ?? 0;
                    const ratio = res?.rewardToCurrencyRatio ?? 0;
                    setAvailableRewardPoints(points);
                    setRewardToCurrencyRatio(ratio);
                    if (points <= 0) setUseRewards(false);
                    else setUseRewards(true);
                } catch (e) {
                    if (!active) return;
                    console.error('Error loading user info');
                    setAvailableRewardPoints(0);
                    setRewardToCurrencyRatio(0);
                    setUseRewards(false);
                }
                if (active) setCustomerLoading(false);
            } else {
                setCustomerLoading(false);
                setUserAddresses([]);
                setSelectedAddress(null);
                setAvailableRewardPoints(0);
                setRewardToCurrencyRatio(0);
                setUseRewards(false);
            }
        };
        loadAddressesAndRewards();
        return () => { active = false; };
    }, [selectedUserId]);

    useEffect(() => {
        let active = true;
        if (!visible) { setProductsLoading(false); return; }
        setProductsLoading(true);
        const timer = window.setTimeout(async () => {
            try {
                const productsData = productSearch.trim()
                    ? await SalesOrderingService.searchProducts(productSearch)
                    : await SalesOrderingService.getMostOrderedProducts(viewAllProducts);
                if (active) setProducts(productsData);
            } catch { if (active) setProducts([]); }
            finally { if (active) setProductsLoading(false); }
        }, productSearch.trim() ? 300 : 0);
        return () => { active = false; window.clearTimeout(timer); };
    }, [visible, productSearch, viewAllProducts]);

    // Compute redeeming points whenever toggle/totals change
    useEffect(() => {
        if (useRewards && rewardToCurrencyRatio > 0 && cart.size > 0) {
            let subtotal = 0;
            let tax = 0;
            cart.forEach(item => {
                subtotal += calculateItemSum(item.unitPrice, item.quantity);
                tax += calculateTotalTax(item.unitPrice, item.quantity, item.tax);
            });

            let deliveryCost = 0;
            if (deliveryMethod === 'COURIER' && selectedCourierId) {
                const provider = courierProviders.find(p => p.providerId === selectedCourierId);
                if (provider) deliveryCost = provider.charges;
            }

            const grandTotal = Math.round(subtotal + tax + deliveryCost);
            const pointsNeeded = Math.floor(grandTotal / rewardToCurrencyRatio);
            setRewardsPointsRedeemed(Math.min(availableRewardPoints, pointsNeeded));
        } else {
            setRewardsPointsRedeemed(0);
        }
    }, [useRewards, availableRewardPoints, rewardToCurrencyRatio, cart, deliveryMethod, selectedCourierId, courierProviders]);

    const loadCourierProviders = async () => {
        const cartItems = Array.from(cart.values());
        const totalWeight = cartItems.reduce((sum, item) => {
            const itemWeight = (Number(item.weight) || 0) * item.quantity;
            return sum + itemWeight;
        }, 0);

        const providers = await SalesOrderingService.getCourierProviders(
            selectedAddress?.state,
            totalWeight
        );

        setCourierProviders(providers);
    };

    const isCourierDeliveryAllowed = useCallback(() => {
        if (cart.size === 0) return false;

        const cartItems = Array.from(cart.values());

        const hasCourierUnavailableProducts = cartItems.some(
            (item) => item.courierAvailable === false
        );
        return !hasCourierUnavailableProducts;
    }, [cart]);

    const isHomeDeliveryAvailable = useCallback(() => {
        if (!selectedAddress || cart.size === 0) return false;

        const addressSupportsHomeDelivery = selectedAddress.homeDeliveryAvailable === true;

        const cartItems = Array.from(cart.values());
        const allProductsHaveHomeDelivery = cartItems.every(
            (item) => item.isHomeDeliveryAvailable === true
        );

        return addressSupportsHomeDelivery && allProductsHaveHomeDelivery;
    }, [selectedAddress, cart]);

    useEffect(() => {
        if (cart.size === 0) {
            return;
        }

        const cartItems = Array.from(cart.values());

        const hasCourierUnavailableProducts = cartItems.some(
            (item) => item.courierAvailable === false
        );

        if (hasCourierUnavailableProducts && deliveryMethod === 'COURIER') {
            setDeliveryMethod('HOME_DELIVERY');
        }
    }, [cart, deliveryMethod]);

    useEffect(() => {
        if (deliveryMethod === 'COURIER' && isCourierDeliveryAllowed() && selectedAddress) {
            loadCourierProviders();
        }
    }, [deliveryMethod, selectedAddress, cart, isCourierDeliveryAllowed]);



    const toggleSelfPickup = () => {
        setIsSelfPickup(prev => {
            const nextValue = !prev;
            if (!nextValue && checkoutStep === 'PAYMENT') {
                setCheckoutStep('CART_DELIVERY');
            }
            return nextValue;
        });
    };


    const handleBuyNowItemDialog = (product: ProductNewModel, quantity: number = 1) => {
        addToCart(product, quantity);
    };

    const addToCart = (product: ProductNewModel, quantity: number = 1) => {
        const currentProduct = salesProduct(product, availabilityRef.current.data);
        if (currentProduct.availabilityPending || currentProduct.inStock === 0) {
            toast.current?.show({ severity: 'warn', summary: 'Unavailable', detail: availabilityRef.current.error || 'This product is unavailable for the selected location, or stock is still being checked.' });
            return false;
        }
        const available = salesAvailableQuantity(product.id, availabilityRef.current.data);
        if (available !== null && (cart.get(product.id)?.quantity ?? 0) + quantity > available) {
            toast.current?.show({ severity: 'warn', summary: 'Available quantity', detail: `Only ${available} available to order for this location.` });
            return false;
        }
        setCart(prev => {
            const newCart = new Map(prev);
            const existing = newCart.get(product.id);
            if (existing) {
                if (available !== null && existing.quantity + quantity > available) return prev;
                newCart.set(product.id, { ...existing, quantity: existing.quantity + quantity });
            } else {
                newCart.set(product.id, { ...product, quantity: quantity });
            }
            return newCart;
        });
        return true;
    };

    const updateQuantity = (productId: number, delta: number) => {
        setCart(prev => {
            const newCart = new Map(prev);
            const item = newCart.get(productId);
            if (!item) return prev;

            const step = Number(item.orderMultiples) > 0 ? Number(item.orderMultiples) : 1;
            const minQty = Number(item.minOrderQty) > 0 ? Number(item.minOrderQty) : 1;

            if (delta > 0) {
                const newQty = Number((item.quantity + step).toFixed(4));
                const available = salesAvailableQuantity(productId, availabilityRef.current.data);
                if (!availabilityRef.current.data || (available !== null && newQty > available)) return prev;
                newCart.set(productId, { ...item, quantity: newQty });
            } else {
                if (item.quantity <= minQty) {
                    return prev;
                }
                let newQty = Number((item.quantity - step).toFixed(4));
                if (newQty < minQty) {
                    newQty = minQty;
                }
                newCart.set(productId, { ...item, quantity: newQty });
            }
            return newCart;
        });
    };

    const handleCartQuantityChange = (productId: number, valueStr: string) => {
        if (valueStr !== "" && !/^\d*\.?\d*$/.test(valueStr)) {
            return;
        }

        setEditingItemId(productId);
        setEditingValueStr(valueStr);

        setCart(prev => {
            const newCart = new Map(prev);
            const item = newCart.get(productId);
            if (!item) return prev;

            let numericVal = valueStr === "" || valueStr === "." ? 0 : parseFloat(valueStr);
            if (isNaN(numericVal)) numericVal = 0;

            newCart.set(productId, { ...item, quantity: numericVal });
            return newCart;
        });
    };

    const handleCartQuantityBlur = (productId: number, valueStr: string) => {
        setEditingItemId(null);
        setEditingValueStr("");

        setCart(prev => {
            const newCart = new Map(prev);
            const item = newCart.get(productId);
            if (!item) return prev;

            const minQty = Number(item.minOrderQty) > 0 ? Number(item.minOrderQty) : 1;
            const step = Number(item.orderMultiples) > 0 ? Number(item.orderMultiples) : 1;

            let val = parseFloat(valueStr);
            if (isNaN(val) || val <= 0) {
                val = 0;
            }

            if (val < minQty) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Validation Warning',
                    detail: 'Entered quantity is less than minimum quantity',
                    life: 3000
                });
                val = minQty;
            } else {
                const steps = Math.round((val - minQty) / step);
                val = minQty + Math.max(0, steps) * step;

                // Avoid floating-point precision issues (e.g. 2.4 -> 2, 2.6 -> 3)
                const getDecimalPlaces = (num: number): number => {
                    const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                    if (!match) return 0;
                    return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
                };
                const decimals = Math.max(getDecimalPlaces(minQty), getDecimalPlaces(step));
                val = parseFloat(val.toFixed(decimals));
            }

            newCart.set(productId, { ...item, quantity: val });
            return newCart;
        });
    };



    const removeFromCart = (productId: number) => {
        setCart(prev => {
            const newCart = new Map(prev);
            newCart.delete(productId);
            return newCart;
        });
    };

    // ── Scanner helpers ────────────────────────────────────────────────────────

    const closeScannerCamera = useCallback(async () => {
        if (html5QrRef.current) {
            try { await html5QrRef.current.stop(); } catch { /* already stopped */ }
            try { html5QrRef.current.clear(); } catch { /* ignore */ }
            html5QrRef.current = null;
        }
        setCameraActive(false);
    }, []);

    const openScanner = useCallback(() => {
        setScanInput('');
        setScannerOpen(true);
        setTimeout(() => scanInputRef.current?.focus(), 200);
    }, []);

    const startCamera = useCallback(async () => {
        if (cameraActive) { await closeScannerCamera(); return; }
        try {
            // @ts-ignore — html5-qrcode v2.3.4 has broken TS definitions but works at runtime
            const qr = new Html5Qrcode('qr-scanner-region');
            html5QrRef.current = qr;
            setCameraActive(true);
            await qr.start(
                { facingMode: 'environment' },
                { fps: 10, qrbox: { width: 220, height: 220 } },
                async (decodedText: string) => {
                    await closeScannerCamera();
                    await scanSubmitRef.current(decodedText);
                },
                () => { /* scan failure — ignore per-frame errors */ }
            );
        } catch (err: any) {
            setCameraActive(false);
            html5QrRef.current = null;
            toast.current?.show({ severity: 'warn', summary: 'Camera', detail: 'Camera access denied or not available' });
        }
    }, [cameraActive, closeScannerCamera]);

    const handleScanSubmit = useCallback(async (rawCode?: string) => {
        const code = (rawCode ?? scanInput).trim();
        if (!code) return;
        setScanLoading(true);
        try {
            const results = await SalesOrderingService.searchProductsByCode(code);
            if (!results || results.length === 0) {
                toast.current?.show({ severity: 'error', summary: 'Not Found', detail: `No product found for code: ${code}` });
            } else if (results.length === 1) {
                if (!addToCart(results[0])) return;
                toast.current?.show({ severity: 'success', summary: 'Added to Cart', detail: `${results[0].name} added to cart` });
                setScannerOpen(false);
                setScanInput('');
            } else {
                // Multiple products — let user pick
                setScanPickerProducts(results);
                setScanPickerOpen(true);
                setScannerOpen(false);
            }
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to search by code. Please try again.' });
        } finally {
            setScanLoading(false);
        }
    }, [scanInput, addToCart]);

    scanSubmitRef.current = handleScanSubmit;

    const handlePickerSelect = useCallback(() => {
        if (scanPickerSelected.size === 0) return;
        const toAdd = scanPickerProducts.filter(p => scanPickerSelected.has(p.id));
        const added = toAdd.filter(p => addToCart(p)).length;
        if (added === 0) return;
        toast.current?.show({
            severity: 'success',
            summary: 'Added to Cart',
            detail: `${added} product${added > 1 ? 's' : ''} added to cart`
        });
        setScanPickerOpen(false);
        setScanPickerProducts([]);
        setScanPickerSelected(new Set());
    }, [scanPickerSelected, scanPickerProducts, addToCart]);

    // ── Scanner dialogs ────────────────────────────────────────────────────────

    const renderRewardsCard = () => {
        if (!selectedUser || availableRewardPoints <= 0) return null;

        return (
            <div className="sales-section-card rewards-card-container mb-2" style={{ border: '1px border-solid #edf2f7', borderRadius: '10px', background: '#ffffff', boxShadow: '0 1px 3px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
                <div className="flex align-items-center justify-content-between p-2 px-3">
                    <div className="flex align-items-center gap-2">
                        <span style={{ fontSize: '1.2rem', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }}>🎁</span>
                        <div className="flex flex-column" style={{ lineHeight: '1.2' }}>
                            <span className="font-bold text-800" style={{ fontSize: '0.85rem' }}>Reward Points</span>
                            <span className="text-500" style={{ fontSize: '0.7rem' }}>1 Point = {rewardToCurrencyRatio.toFixed(2)} pts</span>
                        </div>
                    </div>
                    <div className="flex align-items-center gap-3">
                        <div className="text-right">
                            <div className="text-xs text-500 font-medium" style={{ fontSize: '0.65rem', marginBottom: '-2px' }}>AVAILABLE</div>
                            <div className="font-bold text-900" style={{ fontSize: '0.85rem' }}>{availableRewardPoints} <span className="text-500" style={{ fontSize: '0.7rem' }}>pts</span></div>
                        </div>
                        <InputSwitch
                            checked={useRewards}
                            onChange={(e) => setUseRewards(e.value ?? false)}
                            style={{ transform: 'scale(0.8)' }}
                        />
                    </div>
                </div>
                {useRewards && rewardsPointsRedeemed > 0 && (
                    <div className="p-2 px-3 border-top-1 border-50 bg-green-50 flex justify-content-between align-items-center" style={{ borderTop: '1px dashed #e2e8f0' }}>
                        <span className="text-green-700 font-medium" style={{ fontSize: '0.75rem' }}>Redeeming {rewardsPointsRedeemed} pts</span>
                        <span className="text-green-700 font-bold" style={{ fontSize: '0.75rem' }}>- ₹{totals.rewardDiscount.toFixed(2)}</span>
                    </div>
                )}
            </div>
        );
    };

    const renderScannerDialog = () => (
        <Dialog
            visible={scannerOpen}
            onHide={() => { closeScannerCamera(); setScannerOpen(false); setScanInput(''); }}
            header={
                <div className="flex align-items-center gap-3 scanner-dialog-header-custom">
                    <div className="scanner-header-icon-wrap">
                        <i className="pi pi-qrcode scanner-header-icon" />
                    </div>
                    <div className="flex flex-column">
                        <span className="scanner-header-title">Scan Product</span>
                        <span className="scanner-header-subtitle">Search or scan to add instantly</span>
                    </div>
                </div>
            }
            modal
            style={{ width: '450px', maxWidth: '95vw' }}
            className="scanner-dialog-modern"
            closable={true}
        >
            <div className="scanner-dialog-body-modern">
                {/* Manual input section */}
                <div className="scanner-manual-section-modern">
                    <label className="scanner-label-modern">
                        Enter Barcode / Batch Code
                    </label>
                    <div className="scanner-input-wrapper-modern">
                        <i className="pi pi-barcode scanner-input-icon-modern" />
                        <input
                            ref={scanInputRef}
                            className="scanner-code-input-modern"
                            type="text"
                            placeholder="e.g. B00000018"
                            value={scanInput}
                            onChange={e => setScanInput(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') handleScanSubmit(); }}
                            autoComplete="off"
                            autoCorrect="off"
                            spellCheck={false}
                        />
                        <Button
                            icon={scanLoading ? 'pi pi-spin pi-spinner' : 'pi pi-arrow-right'}
                            className="p-button-rounded p-button-success scanner-search-btn-modern"
                            onClick={() => handleScanSubmit()}
                            disabled={scanLoading || !scanInput.trim()}
                            aria-label="Search"
                        />
                    </div>
                </div>

                <div className="scanner-divider-modern">
                    <span>OR</span>
                </div>

                {/* Camera section */}
                <div className="scanner-camera-section-modern">
                    <div
                        id="qr-scanner-region"
                        className={`scanner-qr-region-modern ${cameraActive ? 'active' : ''}`}
                    />

                    {!cameraActive ? (
                        <div className="scanner-camera-launch-card" onClick={startCamera}>
                            <div className="scanner-camera-icon-blob">
                                <i className="pi pi-camera" />
                            </div>
                            <div className="scanner-camera-card-text">
                                <span className="title">Use Device Camera</span>
                                <span className="subtitle">Scan QR or Barcode instantly</span>
                            </div>
                            <i className="pi pi-chevron-right arrow-icon" />
                        </div>
                    ) : (
                        <Button
                            label="Stop Camera"
                            icon="pi pi-times"
                            className="p-button-danger w-full scanner-stop-btn-modern mt-3"
                            onClick={startCamera}
                        />
                    )}
                </div>
            </div>
        </Dialog>
    );

    const renderScanPickerDialog = () => {
        const togglePickerItem = (id: number) => {
            const product = scanPickerProducts.find(p => p.id === id);
            const available = product && salesProduct(product, deliveryStock.data);
            if (!available || available.availabilityPending || available.inStock === 0) return;
            setScanPickerSelected(prev => {
                const next = new Set(prev);
                if (next.has(id)) next.delete(id);
                else next.add(id);
                return next;
            });
        };
        const selectable = scanPickerProducts.filter(p => { const product = salesProduct(p, deliveryStock.data); return !product.availabilityPending && product.inStock !== 0; });
        const allSelected = selectable.length > 0 && selectable.every(p => scanPickerSelected.has(p.id));
        const toggleAll = () => {
            if (allSelected) setScanPickerSelected(new Set());
            else setScanPickerSelected(new Set(selectable.map(p => p.id)));
        };
        return (
            <Dialog
                visible={scanPickerOpen}
                onHide={() => { setScanPickerOpen(false); setScanPickerProducts([]); setScanPickerSelected(new Set()); }}
                header={
                    <div className="flex align-items-center gap-2">
                        <i className="pi pi-list" style={{ color: '#1565c0' }} />
                        <span>Multiple Products Found</span>
                    </div>
                }
                modal
                style={{ width: '500px', maxWidth: '95vw' }}
                footer={
                    <div className="flex justify-content-between align-items-center" style={{ padding: '0.5rem 0' }}>
                        <span className="text-sm text-500">{scanPickerSelected.size} of {scanPickerProducts.length} selected</span>
                        <div className="flex gap-2">
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                className="p-button-text p-button-secondary"
                                onClick={() => { setScanPickerOpen(false); setScanPickerProducts([]); setScanPickerSelected(new Set()); }}
                            />
                            <Button
                                label={`Add ${scanPickerSelected.size > 0 ? `(${scanPickerSelected.size}) ` : ''}to Cart`}
                                icon="pi pi-cart-plus"
                                className="p-button-success"
                                disabled={scanPickerSelected.size === 0}
                                onClick={handlePickerSelect}
                            />
                        </div>
                    </div>
                }
            >
                <div className="scan-picker-list">
                    {/* Select all row */}
                    <div
                        className="scan-picker-select-all"
                        onClick={toggleAll}
                    >
                        <input
                            type="checkbox"
                            className="scan-picker-checkbox"
                            checked={allSelected}
                            onChange={toggleAll}
                            onClick={e => e.stopPropagation()}
                        />
                        <span className="scan-picker-select-all-label">Select All</span>
                    </div>

                    {scanPickerProducts.map(p => salesProduct(p, deliveryStock.data)).map(p => {
                        const isChecked = scanPickerSelected.has(p.id);
                        return (
                            <div
                                key={p.id}
                                className={`scan-picker-item${isChecked ? ' checked' : ''}`}
                                onClick={() => togglePickerItem(p.id)}
                            >
                                <input
                                    type="checkbox"
                                    className="scan-picker-checkbox"
                                    disabled={p.availabilityPending || p.inStock === 0}
                                    checked={isChecked}
                                    onChange={() => togglePickerItem(p.id)}
                                    onClick={e => e.stopPropagation()}
                                />
                                <div className="scan-picker-img-wrap">
                                    {p.productImageList?.mediaUrl ? (
                                        <img src={p.productImageList.mediaUrl} alt={p.name} className="scan-picker-img" onError={(e: any) => e.target.style.display = 'none'} />
                                    ) : (
                                        <i className="pi pi-box scan-picker-placeholder" />
                                    )}
                                </div>
                                <div className="scan-picker-info">
                                    <div className="scan-picker-name">{p.name}</div>
                                    <div className="scan-picker-price">₹{p.unitPrice?.toFixed(2)}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Dialog>
        );
    };

    // ──────────────────────────────────────────────────────────────────────────

    const cartItemsList = useMemo(() => {
        return Array.from(cart.values()).map(item => ({
            id: item.id,
            name: item.name,
            description: item.description,
            unitPrice: item.unitPrice,
            tax: item.tax,
            weight: item.weight,
            minOrderQty: item.minOrderQty,
            orderMultiples: item.orderMultiples,
            productImageList: item.productImageList,
            categoryID: item.categoryID,
            categoryName: item.categoryName,
            subCategoryID: item.subCategoryID,
            subCategoryName: item.subCategoryName,
            quantity: item.quantity,
            courierAvailable: item.courierAvailable,
            inStock: item.inStock,
            minQuantity: item.minOrderQty,
            isHomeDeliveryAvailable: item.isHomeDeliveryAvailable
        }));
    }, [cart]);

    const totals = useMemo(() => {
        let subtotal = 0;
        let tax = 0;
        cart.forEach(item => {
            subtotal += calculateItemSum(item.unitPrice, item.quantity);
            tax += calculateTotalTax(item.unitPrice, item.quantity, item.tax);
        });

        let deliveryCost = 0;
        if (!isSelfPickup && deliveryMethod === 'COURIER' && selectedCourierId) {
            const provider = courierProviders.find(p => p.providerId === selectedCourierId);
            if (provider) deliveryCost = provider.charges;
        }

        const grandTotal = subtotal + tax + deliveryCost;
        const rewardDiscount = rewardsPointsRedeemed * rewardToCurrencyRatio;
        const finalTotal = Math.max(0, grandTotal - rewardDiscount);

        return {
            subtotal: subtotal,
            tax: tax,
            delivery: deliveryCost,
            grandTotal: grandTotal,
            rewardDiscount: rewardDiscount,
            total: Math.round(finalTotal)
        };
    }, [cart, deliveryMethod, selectedCourierId, courierProviders, rewardsPointsRedeemed, rewardToCurrencyRatio, isSelfPickup]);

    const showMixedCartError = useMemo(() => {
        if (cart.size === 0) return false;
        const items = Array.from(cart.values());
        const allSupportCourier = items.every(item => item.courierAvailable === true);
        const allSupportHomeDelivery = items.every(item => item.isHomeDeliveryAvailable === true);
        return !allSupportCourier && !allSupportHomeDelivery;
    }, [cart]);

    const hasInvalidQuantity = useMemo(() => {
        return Array.from(cart.values()).some(
            item => item.quantity < (Number(item.minOrderQty) > 0 ? Number(item.minOrderQty) : 1)
        );
    }, [cart]);

    const renderCheckoutScreen = () => (
        <div className={`sales-checkout-fullscreen hidden-desktop ${checkoutOpen ? 'open' : ''}`}>
            <div className="sales-checkout-header">
                <div className="flex align-items-center gap-2">
                    <i className="pi pi-arrow-left cursor-pointer" onClick={() => setCheckoutOpen(false)} />
                    <h2>Checkout</h2>
                </div>
                {isPosMapped && (
                    <Button
                        label="Self Pickup"
                        icon={isSelfPickup ? "pi pi-check" : "pi pi-shopping-bag"}
                        className={`sales-self-pickup-btn ${isSelfPickup ? "active" : ""}`}
                        onClick={toggleSelfPickup}
                    />
                )}
            </div>

            <div className="sales-checkout-body">
                {deliveryStock.pending && <p role="status"><i className="pi pi-spin pi-spinner mr-2" aria-hidden="true" />Checking stock for this location and cart…</p>}
                {deliveryStock.error && <p role="alert" className="p-error">{deliveryStock.error}</p>}
                <SalesOrderingCustomer
                    visible={false}
                    onHide={() => { }}
                    onCustomerCreated={() => { }}
                    onAddAddress={() => setShowAddAddressForm(true)}
                    toast={toast}
                    showUserSelection={true}
                    selectedUserId={selectedUserId}
                    selectedUser={selectedUser}
                    selectedAddress={selectedAddress}
                    userAddresses={userAddresses}
                    isSelfPickup={isSelfPickup}
                    onUserSelect={(user) => {
                        if (user && user.userId) {
                            setSelectedUserId(user.userId);
                            setSelectedUser(user);
                        } else {
                            setSelectedUserId(null);
                            setSelectedUser(null);
                        }
                    }}
                    onAddressSelect={setSelectedAddress}
                    onAddCustomer={() => setShowAddUserForm(true)}
                />

                <div className="sales-section-card">
                    <div className="sales-section-header">
                        <span><i className="pi pi-shopping-cart" /> Cart Items ({cart.size})</span>
                    </div>
                    <div className="sales-section-body">
                        {cart.size > 0 ? (
                            Array.from(cart.values()).map(item => (
                                <div key={item.id} className="sales-checkout-cart-item">
                                    <div className="sales-checkout-cart-item-image">
                                        <img
                                            src={item.productImageList?.mediaUrl || ''}
                                            alt={item.name}
                                            onError={(e: any) => e.target.style.display = 'none'}
                                        />
                                    </div>
                                    <div className="sales-checkout-cart-item-details">
                                        <div className="sales-checkout-cart-item-name">{item.name}</div>
                                        <SalesCartStock productId={item.id} quantity={item.quantity} availability={deliveryStock.data} loading={deliveryStock.availabilityLoading} />
                                        <div className="sales-checkout-cart-item-controls">
                                            <div className="sales-stepper">
                                                <div
                                                    className={`sales-stepper-btn${item.quantity <= (Number(item.minOrderQty) > 0 ? Number(item.minOrderQty) : 1) ? ' disabled' : ''}`}
                                                    onClick={() => updateQuantity(item.id, -1)}
                                                >-</div>
                                                <input
                                                    type="text"
                                                    inputMode="decimal"
                                                    className="sales-stepper-val"
                                                    value={editingItemId === item.id ? editingValueStr : (item.quantity === 0 ? "" : item.quantity.toString())}
                                                    onChange={(e) => handleCartQuantityChange(item.id, e.target.value)}
                                                    onFocus={() => {
                                                        setEditingItemId(item.id);
                                                        setEditingValueStr(item.quantity === 0 ? "" : item.quantity.toString());
                                                    }}
                                                    onBlur={(e) => handleCartQuantityBlur(item.id, e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            (e.target as HTMLInputElement).blur();
                                                        }
                                                    }}
                                                    style={{
                                                        width: '56px',
                                                        borderLeft: '1px solid var(--so-border)',
                                                        borderRight: '1px solid var(--so-border)',
                                                        borderTop: 'none',
                                                        borderBottom: 'none',
                                                        background: 'white',
                                                        textAlign: 'center',
                                                        fontWeight: 600,
                                                        fontSize: '0.9rem',
                                                        color: 'var(--so-text)',
                                                        outline: 'none',
                                                        padding: '0.4rem 0',
                                                        margin: 0,
                                                        boxSizing: 'border-box'
                                                    }}
                                                />
                                                <button type="button" aria-label={`Increase quantity for ${item.name}`} disabled={cannotIncrease(item)} className={`sales-stepper-btn${cannotIncrease(item) ? ' disabled' : ''}`} onClick={() => updateQuantity(item.id, 1)}>+</button>
                                            </div>
                                            <div className="font-bold text-green-600">₹{(item.unitPrice * item.quantity).toFixed(2)}</div>
                                        </div>
                                    </div>
                                    <i className="pi pi-trash text-red-500 cursor-pointer" onClick={() => removeFromCart(item.id)} />
                                </div>
                            ))
                        ) : (
                            <div className="flex flex-column align-items-center justify-content-center py-5 text-center">
                                <i className="pi pi-shopping-bag text-green-500 text-4xl mb-3" />
                                <p className="text-800 font-bold mb-3" style={{ fontSize: '1rem' }}>Your cart is empty.</p>
                                <Button
                                    label="Continue Shopping"
                                    icon="pi pi-chevron-left"
                                    className="p-button-success p-button-outlined p-button-sm"
                                    onClick={() => setCheckoutOpen(false)}
                                    style={{ borderRadius: '20px', fontWeight: 'bold' }}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {!isSelfPickup && selectedAddress && cart.size > 0 && (
                    <div className="sales-section-card" ref={deliverySectionRefMobile}>
                        <div className="sales-section-header">
                            <span><i className="pi pi-truck" /> Delivery Method</span>
                        </div>
                        <div className="sales-section-body">
                            {isHomeDeliveryAvailable() && (
                                <div className={`sales-delivery-option ${deliveryMethod === 'HOME_DELIVERY' ? 'selected' : ''}`}
                                    onClick={() => setDeliveryMethod('HOME_DELIVERY')}>
                                    <span><i className="pi pi-home mr-2" /> Home Delivery</span>
                                    <span className="sales-badge-free">Free</span>
                                </div>
                            )}

                            {isCourierDeliveryAllowed() && !isHomeDeliveryAvailable() && (
                                <div className={`sales-delivery-option ${deliveryMethod === 'COURIER' ? 'selected' : ''}`}
                                    onClick={() => setDeliveryMethod('COURIER')}>
                                    <span><i className="pi pi-box mr-2" /> Courier</span>
                                    <span className="sales-badge-free" style={{ color: '#2c3e50' }}>Charges Apply</span>
                                </div>
                            )}

                            {selectedAddress && !isCourierDeliveryAllowed() && !isHomeDeliveryAvailable() && cart.size > 0 && (
                                <Message
                                    severity="error"
                                    text="Some products are not suitable for courier. Please remove from Basket."
                                    className="w-full justify-content-start"
                                />
                            )}

                            {deliveryMethod === 'COURIER' && courierProviders.length > 0 && (
                                <div className="mt-3" ref={courierTableRefMobile}>
                                    <DataTable
                                        value={courierProviders}
                                        selectionMode="single"
                                        selection={courierProviders.find(p => p.providerId === selectedCourierId)}
                                        onSelectionChange={(e: any) => setSelectedCourierId(e.value?.providerId)}
                                        dataKey="providerId"
                                        size="small"
                                        showGridlines
                                    >
                                        <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                                        <Column field="providerName" header="Courier Provider" body={(provider) => {
                                            if (provider.providerId === 0) {
                                                return (
                                                    <img
                                                        src={process.env.PUBLIC_URL + '/assests/images/home-delivery-service.png'}
                                                        alt="Home Delivery"
                                                        style={{ width: 120 }}
                                                    />
                                                );
                                            } else if (provider.providerId === 1) {
                                                return (
                                                    <img
                                                        src={process.env.PUBLIC_URL + '/assests/images/professinal-courier01.jpg'}
                                                        alt="Professional Courier"
                                                        style={{ width: 120 }}
                                                    />
                                                );
                                            } else if (provider.providerId === 2) {
                                                return (
                                                    <img
                                                        src={process.env.PUBLIC_URL + '/assests/images/dtdc.png'}
                                                        alt="DTDC"
                                                        style={{ width: 120 }}
                                                    />
                                                );
                                            } else {
                                                return <span>{provider.providerName}</span>;
                                            }
                                        }}></Column>
                                        <Column field="charges" header="Courier Charges" body={(provider) => (
                                            <span className="font-bold">₹{provider.charges.toFixed(2)}</span>
                                        )}></Column>
                                    </DataTable>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {!isSelfPickup && (
                    <div className="sales-section-card">
                        <div className="sales-section-header">
                            <span><i className="pi pi-wallet" /> Payment Method</span>
                        </div>
                        <div className="sales-section-body">
                            {cart.size > 0 ? (
                                totals.total > 0 ? (
                                    <SalesOrderingPaymentMode
                                        paymentmode={(method: any) => {
                                            setSelectedPaymentObj(method);
                                            if (!method) setPaymentMethod('CASH');
                                            else if (method.code === 'COD') setPaymentMethod('CASH');
                                            else if (method.code?.toUpperCase().includes('UPI')) setPaymentMethod('UPI');
                                            else if (method.mode?.toLowerCase().includes('card')) setPaymentMethod('CARD');
                                            else setPaymentMethod('ONLINE');
                                        }}
                                        isSelfPickup={isSelfPickup}
                                        deliveryMethod={deliveryMethod}
                                        selectedUserId={selectedUserId}
                                    />
                                ) : (
                                    <div className="p-4 text-center border-round surface-100">
                                        <i className="pi pi-check-circle text-4xl text-green-500 mb-2" />
                                        <div className="font-bold text-lg">Order Fully Covered by Rewards</div>
                                        <p className="text-600 mb-0">No additional payment required.</p>
                                        <div className="mt-3 p-2 bg-green-50 text-green-700 font-bold border-round">
                                            Payment Mode: Reward
                                        </div>
                                    </div>
                                )
                            ) : null}
                        </div>
                    </div>
                )}

                {renderRewardsCard()}

                <div className="sales-section-card">
                    <div className="sales-section-header">
                        <span><i className="pi pi-calculator" /> Order Summary</span>
                    </div>
                    <div className="sales-section-body">
                        <div className="sales-summary-card">
                            <div className="sales-summary-row">
                                <span>Subtotal:</span>
                                <span className="font-bold">₹{totals.subtotal.toFixed(0)}</span>
                            </div>
                            <div className="sales-summary-row">
                                <span>Tax:</span>
                                <span className="font-bold">₹{totals.tax.toFixed(0)}</span>
                            </div>
                            {totals.delivery > 0 && (
                                <div className="sales-summary-row">
                                    <span>Delivery:</span>
                                    <span className="font-bold">₹{totals.delivery.toFixed(0)}</span>
                                </div>
                            )}
                            {totals.rewardDiscount > 0 && (
                                <div className="sales-summary-row text-green-600">
                                    <span>Rewards Used:</span>
                                    <span className="font-bold">- ₹{totals.rewardDiscount.toFixed(0)}</span>
                                </div>
                            )}
                            <div className="sales-summary-total">
                                <span>Total:</span>
                                <div className="flex flex-column align-items-end">
                                    {totals.rewardDiscount > 0 && (
                                        <span className="text-sm text-500 line-through mr-1">₹{totals.grandTotal.toFixed(0)}</span>
                                    )}
                                    <span className="total-amount">₹{totals.total.toFixed(0)}</span>
                                </div>
                            </div>
                            {showMixedCartError && (
                                <div style={{ backgroundColor: '#ffcdd2', color: '#c62828', padding: '1rem', borderRadius: '4px', marginTop: '1rem', fontSize: '0.9rem', display: 'flex', alignItems: 'start' }}>
                                    <i className="pi pi-times-circle mr-2" style={{ fontSize: '1.2rem', marginTop: '2px' }} />
                                    <span>Combination of shippable and non-shippable products cannot be delivered together. Please create separate orders.</span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="sales-checkout-footer">
                <Button
                    label={totals.total <= 0 ? "Place Order Now" : `Proceed to Checkout - ₹${totals.total.toFixed(2)}`}
                    className="w-full p-button-success p-button-lg sales-checkout-btn-mobile"
                    icon="pi pi-check"
                    disabled={checkoutBlocked || placingOrder || cart.size === 0 || !selectedUser || (!isSelfPickup && !selectedAddress) || (totals.total > 0 && !selectedPaymentObj && !isSelfPickup) || showMixedCartError || hasInvalidQuantity || (!isSelfPickup && !!selectedAddress && !isHomeDeliveryAvailable() && !isCourierDeliveryAllowed() && cart.size > 0) || (!isSelfPickup && deliveryMethod === 'COURIER' && courierProviders.length > 0 && !selectedCourierId)}
                    onClick={() => !isSelfPickup ? handlePlaceOrder() : proceedToPayment()}
                />
            </div>

            {/* Confirm Dialog */}
            <ConfirmDialog
                visible={showAddressConfirmDialog}
                onHide={() => setShowAddressConfirmDialog(false)}
                message="Do you want to add a new address?"
                header="Confirmation"
                icon="pi pi-exclamation-triangle"
                accept={() => { setShowAddressConfirmDialog(false); setShowAddAddressForm(true); }}
                reject={() => setShowAddressConfirmDialog(false)}
            />


            {/* Add Address Dialog - Component */}
            <SalesOrderingAddress
                visible={showAddAddressForm}
                onHide={() => setShowAddAddressForm(false)}
                onAddressSaved={async (newAddressId, addressData) => {
                    const targetUserId = selectedUserId || createdUserId;
                    if (targetUserId) {
                        let optimisticAddress: UserAddressDTO | null = null;

                        // 1. Optimistic update
                        if (newAddressId && addressData) {
                            optimisticAddress = {
                                addressId: newAddressId,
                                addressLine1: addressData.addressLine1,
                                addressLine2: addressData.addressLine2,
                                landmark: addressData.landmark,
                                pincode: addressData.pincode,
                                city: addressData.city,
                                stateId: addressData.stateId,
                                state: addressData.state,
                                country: addressData.country,
                                areaId: Number(addressData.areaId),
                                name: selectedUser?.name || '',
                                mobile: selectedUser?.mobile || ''
                            };

                            // Immediately update state and select
                            setUserAddresses(prev => [optimisticAddress!, ...prev]);
                            setSelectedAddress(optimisticAddress);
                        }

                        // 2. Background refresh to ensure consistency
                        try {
                            const addresses = await SalesOrderingService.getUserAddresses(targetUserId);

                            // 3. Merge Strategy: 
                            // If we have an optimistic address, check if it's in the fetched list.
                            // If NOT, we must preserve it by appending it manually.
                            let finalAddresses = addresses;

                            if (optimisticAddress) {
                                const existsInBackend = addresses.some(a => a.addressId === optimisticAddress!.addressId);
                                if (!existsInBackend) {
                                    finalAddresses = [optimisticAddress, ...addresses];
                                }
                                // Ensure it stays selected
                                setSelectedAddress(optimisticAddress);
                            } else {
                                // Fallback logic if no optimistic address (e.g. error or simple refresh)
                                if (addresses.length > 0 && !selectedAddress) {
                                    setSelectedAddress(addresses[0]);
                                }
                            }

                            setUserAddresses(finalAddresses);

                        } catch (e) {
                            console.error("Failed to refresh addresses", e);
                        }
                    }
                }}
                userId={selectedUserId || createdUserId}
                toast={toast}
            />
        </div >
    );



    const renderDeliverySection = () => (
        <div className="sales-section-card" ref={deliverySectionRef}>
            <div className="sales-section-header">
                <span><i className="pi pi-truck" /> Delivery Method</span>
            </div>
            <div className="sales-section-body">
                {/* Home Delivery - Only show if available for address */}
                {isHomeDeliveryAvailable() && (
                    <div className={`sales-delivery-option ${deliveryMethod === 'HOME_DELIVERY' ? 'selected' : ''}`}
                        onClick={() => setDeliveryMethod('HOME_DELIVERY')}>
                        <span><i className="pi pi-home mr-2" /> Home Delivery</span>
                        <span className="sales-badge-free">Free</span>
                    </div>
                )}

                {/* Only show courier option if cart products allow it AND home delivery is NOT available */}
                {isCourierDeliveryAllowed() && !isHomeDeliveryAvailable() && (
                    <div className={`sales-delivery-option ${deliveryMethod === 'COURIER' ? 'selected' : ''}`}
                        onClick={() => setDeliveryMethod('COURIER')}>
                        <span><i className="pi pi-box mr-2" /> Courier</span>
                        <span className="sales-badge-free" style={{ color: '#2c3e50' }}>Charges Apply</span>
                    </div>
                )}

                {selectedAddress && !isCourierDeliveryAllowed() && !isHomeDeliveryAvailable() && cart.size > 0 && (
                    <Message
                        severity="error"
                        text="Some products are not suitable for courier. Please remove from Basket."
                        className="w-full justify-content-start"
                    />
                )}

                {deliveryMethod === 'COURIER' && courierProviders.length > 0 && (
                    <div className="mt-3" ref={courierTableRef}>
                        <DataTable
                            value={courierProviders}
                            selectionMode="single"
                            selection={courierProviders.find(p => p.providerId === selectedCourierId)}
                            onSelectionChange={(e: any) => setSelectedCourierId(e.value?.providerId)}
                            dataKey="providerId"
                            size="small"
                            showGridlines
                        >
                            <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                            <Column field="providerName" header="Courier Provider" body={(provider) => {
                                // Use courierProviderID to determine which logo to display
                                // ID 0 = Home Delivery, ID 1 = Professional Courier, ID 2 = DTDC
                                if (provider.providerId === 0) {
                                    return (
                                        <img
                                            src={process.env.PUBLIC_URL + '/assests/images/home-delivery-service.png'}
                                            alt="Home Delivery"
                                            style={{ width: 120 }}
                                        />
                                    );
                                } else if (provider.providerId === 1) {
                                    return (
                                        <img
                                            src={process.env.PUBLIC_URL + '/assests/images/professinal-courier01.jpg'}
                                            alt="Professional Courier"
                                            style={{ width: 120 }}
                                        />
                                    );
                                } else if (provider.providerId === 2) {
                                    return (
                                        <img
                                            src={process.env.PUBLIC_URL + '/assests/images/dtdc.png'}
                                            alt="DTDC"
                                            style={{ width: 120 }}
                                        />
                                    );
                                } else {
                                    return <span>{provider.providerName}</span>;
                                }
                            }}></Column>
                            <Column field="charges" header="Courier Charges" body={(provider) => (
                                <span className="font-bold">₹{provider.charges.toFixed(2)}</span>
                            )}></Column>
                        </DataTable>
                    </div>
                )}
            </div>
        </div>
    );



    const renderCartSummary = () => (
        <>
            <div className="sales-cart-items">
                {Array.from(cart.values()).map(item => (
                    <div key={item.id} className="sales-cart-item">
                        <div className="flex justify-content-between mb-2">
                            <div className="font-bold text-sm flex-1">{item.name}</div>
                            <i className="pi pi-trash text-red-500 cursor-pointer text-sm ml-2"
                                onClick={() => removeFromCart(item.id)} />
                        </div>
                        <div className="flex justify-content-between align-items-center">
                            <div className="sales-stepper">
                                <div
                                    className={`sales-stepper-btn${item.quantity <= Math.max(1, Number(item.minOrderQty) || 1) ? ' disabled' : ''}`}
                                    onClick={() => updateQuantity(item.id, -1)}
                                >-</div>
                                <input
                                    type="text"
                                    inputMode="decimal"
                                    className="sales-stepper-val"
                                    value={item.quantity === 0 ? "" : item.quantity}
                                    onChange={(e) => handleCartQuantityChange(item.id, e.target.value)}
                                    onBlur={(e) => handleCartQuantityBlur(item.id, e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            (e.target as HTMLInputElement).blur();
                                        }
                                    }}
                                    style={{
                                        width: '56px',
                                        borderLeft: '1px solid var(--so-border)',
                                        borderRight: '1px solid var(--so-border)',
                                        borderTop: 'none',
                                        borderBottom: 'none',
                                        background: 'white',
                                        textAlign: 'center',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        color: 'var(--so-text)',
                                        outline: 'none',
                                        padding: '0.4rem 0',
                                        margin: 0,
                                        boxSizing: 'border-box'
                                    }}
                                />
                                <div className="sales-stepper-btn" onClick={() => updateQuantity(item.id, 1)}>+</div>
                            </div>
                            <div className="font-bold text-green-600">₹{(item.unitPrice * item.quantity).toFixed(2)}</div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="sales-cart-footer">
                <div className="sales-summary-row">
                    <span>Subtotal:</span>
                    <span className="font-bold">₹{totals.subtotal.toFixed(2)}</span>
                </div>
                <div className="sales-summary-row">
                    <span>Tax:</span>
                    <span className="font-bold">₹{totals.tax.toFixed(2)}</span>
                </div>
                {totals.delivery > 0 && (
                    <div className="sales-summary-row">
                        <span>Delivery:</span>
                        <span className="font-bold">₹{totals.delivery.toFixed(0)}</span>
                    </div>
                )}
                {totals.rewardDiscount > 0 && (
                    <div className="sales-summary-row text-green-600">
                        <span>Rewards Used:</span>
                        <span className="font-bold">- ₹{totals.rewardDiscount.toFixed(0)}</span>
                    </div>
                )}
                <div className="sales-summary-row mt-3 pt-3 border-top-1 border-300">
                    <span className="font-bold text-lg">Total:</span>
                    <div className="flex flex-column align-items-end">
                        {totals.rewardDiscount > 0 && (
                            <span className="text-sm text-500 line-through mr-1">₹{totals.grandTotal.toFixed(0)}</span>
                        )}
                        <span className="font-bold text-green-600 text-lg">₹{totals.total.toFixed(0)}</span>
                    </div>
                </div>
                {showMixedCartError && (
                    <div style={{ backgroundColor: '#ffcdd2', color: '#c62828', padding: '1rem', borderRadius: '4px', marginTop: '1rem', fontSize: '0.9rem', display: 'flex', alignItems: 'start' }}>
                        <i className="pi pi-times-circle mr-2" style={{ fontSize: '1.2rem', marginTop: '2px' }} />
                        <span>Combination of shippable and non-shippable products cannot be delivered together. Please create separate orders.</span>
                    </div>
                )}
                <Button
                    label={totals.total <= 0 ? "Place Order Now" : "Proceed To Checkout"}
                    className="w-full mt-3 p-button-success sales-checkout-btn-mobile"
                    disabled={checkoutBlocked || placingOrder || !selectedUser || (!isSelfPickup && !selectedAddress) || showMixedCartError}
                    onClick={() => totals.total <= 0 && !isSelfPickup ? handlePlaceOrder() : proceedToPayment()}
                />
            </div>
        </>
    );

    // Autoscroll for visibility of errors and courier options
    useEffect(() => {
        if (prevIsSelfPickup.current === true && isSelfPickup === false) {
            if (selectedAddress && cart.size > 0) {
                const timer = setTimeout(() => {
                    const sidebar = document.querySelector('.sales-sidebar') as HTMLElement;
                    const checkoutBody = document.querySelector('.sales-checkout-body') as HTMLElement;

                    if (sidebar && deliverySectionRef.current) {
                        sidebar.scrollTo({
                            top: deliverySectionRef.current.offsetTop - 20,
                            behavior: 'smooth'
                        });
                    } else if (checkoutBody && deliverySectionRefMobile.current) {
                        checkoutBody.scrollTo({
                            top: deliverySectionRefMobile.current.offsetTop - 20,
                            behavior: 'smooth'
                        });
                    }
                }, 300);
                return () => clearTimeout(timer);
            }
        }
        prevIsSelfPickup.current = isSelfPickup;
    }, [isSelfPickup, selectedAddress, cart.size]);

    useEffect(() => {
        // If there is a mixed cart error, scroll to it so the user sees it immediately
        if (showMixedCartError && selectedAddress) {
            const timer = setTimeout(() => {
                const elementToScroll = deliverySectionRef.current || deliverySectionRefMobile.current;
                if (elementToScroll) {
                    elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [showMixedCartError, selectedAddress]);

    useEffect(() => {
        if (deliveryMethod === 'COURIER' && courierProviders.length > 0) {
            // Scroll specifically to courier providers table when it is relevant
            const timer = setTimeout(() => {
                const tableToScroll = courierTableRef.current || courierTableRefMobile.current;
                if (tableToScroll) {
                    tableToScroll.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [deliveryMethod, courierProviders]);

    const layoutClass = `sales-layout-container ${cart.size > 0 ? 'cart-visible' : ''}`;

    return (
        <Dialog
            visible={visible}
            onHide={onHide}

            header={
                <div className="flex flex-column w-full gap-1">
                    <div className="flex justify-content-between align-items-center w-full">
                        <span className="text-xl font-bold text-black-600">Sales Ordering</span>
                        <div className="flex gap-2 align-items-center">
                            {isPosMapped && (
                                <Button
                                    label="Self Pickup"
                                    icon={isSelfPickup ? "pi pi-check" : "pi pi-shopping-bag"}
                                    className={`hidden-mobile sales-self-pickup-btn ${isSelfPickup ? "active" : ""}`}
                                    onClick={toggleSelfPickup}
                                />
                            )}
                            <i className="pi pi-times cursor-pointer hover:text-red-500 p-2" onClick={onHide} />
                        </div>
                    </div>
                    <div className="flex align-items-center gap-2 flex-wrap" style={{ fontSize: '0.85rem' }} aria-live="polite">
                        {customerLoading && <span role="status" className="text-500"><i className="pi pi-spin pi-spinner mr-2" aria-hidden="true" />Loading customer details…</span>}
                        {deliveryStock.pending && <span role="status" className="text-500"><i className="pi pi-spin pi-spinner mr-2" aria-hidden="true" />Checking stock for this location and cart…</span>}
                        {deliveryStock.error && <span role="alert" className="p-error">{deliveryStock.error}</span>}
                        {deliveryStock.data && <span>{salesStockLocationLabel(deliveryStock.data, isSelfPickup)}</span>}
                        <Button label="Refresh stock" icon="pi pi-refresh" text size="small" loading={deliveryStock.availabilityLoading} disabled={placingOrder || deliveryStock.availabilityLoading} onClick={deliveryStock.refresh} style={{ padding: '0.15rem 0.5rem' }} />
                    </div>
                </div>
            }
            modal
            closable={false}
            className="sales-ordering-dialog"
            style={{ width: '95vw', maxWidth: '1400px', height: '90vh' }}
            maximized={false}
            contentClassName="p-0"
        >

            {checkoutStep === 'PAYMENT' ? (
                <SalesOrderingPayment
                    cart={cart}
                    totals={totals}
                    deliveryMethod={deliveryMethod}
                    selectedUser={selectedUser}
                    selectedAddress={selectedAddress}
                    isSelfPickup={isSelfPickup}
                    onPaymentMethodChange={(method: any) => {
                        setSelectedPaymentObj(method);
                        if (!method) setPaymentMethod('CASH'); // Prevent undefined error
                        else if (method.code === 'COD') setPaymentMethod('CASH');
                        else if (method.code?.toUpperCase().includes('UPI')) setPaymentMethod('UPI');
                        else if (method.mode?.toLowerCase().includes('card')) setPaymentMethod('CARD');
                        else setPaymentMethod('ONLINE');
                    }}

                    onPlaceOrder={handlePlaceOrder}
                    onBack={() => setCheckoutStep('CART_DELIVERY')}
                    isPlacingOrder={placingOrder || checkoutBlocked}
                    activePosId={activePosId}
                    selectedBatches={selectedBatches}
                    onBatchChange={(productId, batches) => {
                        setSelectedBatches(prev => ({ ...prev, [productId]: batches }));
                    }}
                />
            ) : (
                <div className={layoutClass}>
                    {/* Sidebar (Desktop/Tablet) */}
                    <div className="sales-sidebar hidden-mobile">
                        <SalesOrderingCustomer
                            visible={false}
                            onHide={() => { }}
                            onCustomerCreated={() => { }}
                            onAddAddress={() => setShowAddAddressForm(true)}
                            toast={toast}
                            showUserSelection={true}
                            selectedUserId={selectedUserId}
                            selectedUser={selectedUser}
                            selectedAddress={selectedAddress}
                            userAddresses={userAddresses}
                            isSelfPickup={isSelfPickup}
                            onUserSelect={(user) => {
                                if (user && user.userId) {
                                    setSelectedUserId(user.userId);
                                    setSelectedUser(user);
                                } else {
                                    setSelectedUserId(null);
                                    setSelectedUser(null);
                                }
                            }}
                            onAddressSelect={setSelectedAddress}
                            onAddCustomer={() => setViewMode('ADD_USER')}
                        />
                        {/* Only show delivery if NOT Direct Delivery */}
                        {!isSelfPickup && selectedAddress && cart.size > 0 && renderDeliverySection()}
                    </div>

                    {/* Main Content - Products */}
                    <div className="sales-content">
                        <div className="sales-search-bar flex gap-2">
                            <span className="p-input-icon-left flex-1">
                                <i className="pi pi-search" />
                                <InputText
                                    className="w-full"
                                    placeholder="Search products..."
                                    value={productSearch}
                                    onChange={(e) => setProductSearch(e.target.value)}
                                />
                            </span>
                            {/* Scanner button */}
                            <Button
                                icon="pi pi-qrcode"
                                tooltip="Scan barcode / QR / batch code"
                                tooltipOptions={{ position: 'bottom' }}
                                className="scanner-trigger-btn p-button-outlined p-button-success"
                                onClick={openScanner}
                                aria-label="Scan product"
                            />
                            <Button
                                label={viewAllProducts ? "Show Top Items" : "View All"}
                                icon={viewAllProducts ? "pi pi-filter" : "pi pi-list"}
                                onClick={() => setViewAllProducts(!viewAllProducts)}
                                className={`${viewAllProducts ? "p-button-secondary" : "p-button-primary"} sales-view-all-btn`}
                            />
                        </div>

                        <div className="sales-product-grid" aria-busy={productsLoading || deliveryStock.availabilityLoading}>
                            {productsLoading || deliveryStock.availabilityLoading || loading ? (
                                <div role="status" className="flex flex-column align-items-center justify-content-center w-full" style={{ padding: '3rem', gridColumn: '1 / -1' }}>
                                    <i className="pi pi-spin pi-spinner text-400" style={{ fontSize: '3rem', marginBottom: '1rem' }} />
                                    <span className="text-600 text-xl font-medium">{deliveryStock.availabilityLoading ? 'Checking products for this location…' : 'Loading products...'}</span>
                                </div>
                            ) : products.length > 0 ? (
                                availableProducts.map(product => (
                                    <div key={product.id}>
                                        <ProductCardItems
                                            productData={product}
                                            showProductQuickView={(p) => {
                                                setQuickViewProduct(p);
                                                setQuickViewVisible(true);
                                            }}
                                            buyNowItemDialog={handleBuyNowItemDialog}
                                            isAdmin={true}
                                            cartItems={cartItemsList}
                                            isCompact={true}
                                        />
                                    </div>
                                ))
                            ) : (
                                <div className="flex flex-column align-items-center justify-content-center w-full" style={{ padding: '3rem', gridColumn: '1 / -1' }}>
                                    <i className="pi pi-box text-400" style={{ fontSize: '3rem', marginBottom: '1rem' }} />
                                    <span className="text-600 text-xl font-medium">No result found</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Cart Panel (Desktop) */}
                    {cart.size > 0 && (
                        <div className="sales-cart-panel" style={{ maxHeight: 'calc(100% - 1rem)' }}>
                            <div className="sales-cart-header" style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0', padding: '1rem' }}>
                                <div className="flex justify-content-between align-items-center">
                                    <span>Cart ({cart.size})</span>
                                    <span className="text-green-600 cursor-pointer text-sm font-bold"
                                        onClick={() => setCart(new Map())}>
                                        <i className="pi pi-trash mr-1" /> Clear
                                    </span>
                                </div>
                            </div>

                            {/* Scrollable Content: Cart Items + Summary */}
                            <div className="sales-cart-scrollable">
                                <div className="sales-cart-items">
                                    {Array.from(cart.values()).map(item => (
                                        <div key={item.id} className="sales-cart-item">
                                            <div className="flex justify-content-between mb-2">
                                                <div className="font-bold text-sm flex-1">{item.name}</div>
                                                <i className="pi pi-trash text-red-500 cursor-pointer text-sm ml-2"
                                                    onClick={() => removeFromCart(item.id)} />
                                            </div>
                                            <SalesCartStock productId={item.id} quantity={item.quantity} availability={deliveryStock.data} loading={deliveryStock.availabilityLoading} />
                                            <div className="flex justify-content-between align-items-center">
                                                <div className="sales-stepper">
                                                    <div
                                                        className={`sales-stepper-btn${item.quantity <= (Number(item.minOrderQty) > 0 ? Number(item.minOrderQty) : 1) ? ' disabled' : ''}`}
                                                        onClick={() => updateQuantity(item.id, -(Number(item.orderMultiples) || 1))}
                                                    >-</div>
                                                    <input
                                                        type="text"
                                                        inputMode="decimal"
                                                        className="sales-stepper-val"
                                                        value={editingItemId === item.id ? editingValueStr : (item.quantity === 0 ? "" : item.quantity.toString())}
                                                        onChange={(e) => handleCartQuantityChange(item.id, e.target.value)}
                                                        onFocus={() => {
                                                            setEditingItemId(item.id);
                                                            setEditingValueStr(item.quantity === 0 ? "" : item.quantity.toString());
                                                        }}
                                                        onBlur={(e) => handleCartQuantityBlur(item.id, e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                (e.target as HTMLInputElement).blur();
                                                            }
                                                        }}
                                                        style={{
                                                            width: '56px',
                                                            borderLeft: '1px solid var(--so-border)',
                                                            borderRight: '1px solid var(--so-border)',
                                                            borderTop: 'none',
                                                            borderBottom: 'none',
                                                            background: 'white',
                                                            textAlign: 'center',
                                                            fontWeight: 600,
                                                            fontSize: '0.9rem',
                                                            color: 'var(--so-text)',
                                                            outline: 'none',
                                                            padding: '0.4rem 0',
                                                            margin: 0,
                                                            boxSizing: 'border-box'
                                                        }}
                                                    />
                                                    <button type="button" aria-label={`Increase quantity for ${item.name}`} disabled={cannotIncrease(item)} className={`sales-stepper-btn${cannotIncrease(item) ? ' disabled' : ''}`} onClick={() => updateQuantity(item.id, (Number(item.orderMultiples) || 1))}>+</button>
                                                </div>
                                                <div className="font-bold text-green-600">₹{(item.unitPrice * item.quantity).toFixed(2)}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Summary Section */}
                                <div className="sales-cart-summary">
                                    <div className="sales-summary-row">
                                        <span>Subtotal:</span>
                                        <span className="font-bold">₹{totals.subtotal.toFixed(2)}</span>
                                    </div>
                                    <div className="sales-summary-row">
                                        <span>Tax:</span>
                                        <span className="font-bold">₹{totals.tax.toFixed(2)}</span>
                                    </div>
                                    {totals.delivery > 0 && (
                                        <div className="sales-summary-row">
                                            <span>Delivery:</span>
                                            <span className="font-bold">₹{totals.delivery.toFixed(0)}</span>
                                        </div>
                                    )}
                                    {totals.rewardDiscount > 0 && (
                                        <div className="sales-summary-row text-green-600">
                                            <span>Rewards Used:</span>
                                            <span className="font-bold">- ₹{totals.rewardDiscount.toFixed(0)}</span>
                                        </div>
                                    )}
                                    <div className="sales-summary-row mt-3 pt-3 border-top-1 border-300">
                                        <span className="font-bold text-lg">Total:</span>
                                        <div className="flex flex-column align-items-end">
                                            {totals.rewardDiscount > 0 && (
                                                <span className="text-sm text-500 line-through mr-1">₹{totals.grandTotal.toFixed(0)}</span>
                                            )}
                                            <span className="font-bold text-green-600 text-lg">₹{totals.total.toFixed(0)}</span>
                                        </div>
                                    </div>
                                    {showMixedCartError && (
                                        <div style={{ backgroundColor: '#ffcdd2', color: '#c62828', padding: '1rem', borderRadius: '4px', marginTop: '1rem', fontSize: '0.9rem', display: 'flex', alignItems: 'start' }}>
                                            <i className="pi pi-times-circle mr-2" style={{ fontSize: '1.2rem', marginTop: '2px' }} />
                                            <span>Combination of shippable and non-shippable products cannot be delivered together. Please create separate orders.</span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Reward Points Card */}
                            <div className="px-3">
                                {renderRewardsCard()}
                            </div>

                            {/* Fixed Checkout Button */}
                            <div className="sales-cart-checkout-btn">
                                <Button
                                    label={totals.total <= 0 ? "Place Order Now" : `Proceed to Checkout  ₹${totals.total.toFixed(0)}`}
                                    className="w-full p-button-success"
                                    disabled={checkoutBlocked || placingOrder || !selectedUser || (!isSelfPickup && !selectedAddress) || showMixedCartError || hasInvalidQuantity || (!isSelfPickup && !!selectedAddress && !isHomeDeliveryAvailable() && !isCourierDeliveryAllowed() && cart.size > 0) || (!isSelfPickup && deliveryMethod === 'COURIER' && courierProviders.length > 0 && !selectedCourierId)}
                                    onClick={() => totals.total <= 0 && !isSelfPickup ? handlePlaceOrder() : proceedToPayment()}
                                />
                            </div>
                        </div>
                    )}

                    {cart.size > 0 && (
                        <div className="sales-floating-cart hidden-desktop" onClick={() => setCheckoutOpen(true)}>
                            <i className="pi pi-shopping-cart" style={{ fontSize: '1.5rem' }} />
                            <div className="cart-badge">{cart.size}</div>
                        </div>
                    )}

                    {/* Full Screen Checkout (Mobile) */}
                    {renderCheckoutScreen()}
                </div>
            )}

            <Dialog
                visible={orderSuccess.visible}
                onHide={() => {
                    setOrderSuccess(prev => ({ ...prev, visible: false }));
                    onHide();
                    resetState();
                }}
                header="Order Successfully Placed"
                modal
                style={{ width: '400px', maxWidth: '95vw' }}
                breakpoints={{ '641px': '95vw' }}
                closable={true}
            >
                <div className="flex flex-column align-items-center text-center">
                    <i className="pi pi-check-circle text-green-500" style={{ fontSize: '4rem', marginBottom: '1rem' }} />
                    <div className="text-xl font-bold mb-2">Thank you for your order!</div>
                    <p className="text-600 mb-4">Your order has been placed successfully.</p>

                    <div className="w-full surface-100 p-3 border-round mb-4">
                        <div className="flex justify-content-between mb-2 align-items-center">
                            <span className="text-600">Order ID:</span>
                            <span
                                className="order-id-badge font-bold"
                                style={{ cursor: 'default' }}
                            >
                                {orderSuccess.orderId}
                            </span>
                        </div>
                        <div className="flex justify-content-between mb-2">
                            <span className="text-600">Date:</span>
                            <span className="font-bold">{orderSuccess.date}</span>
                        </div>
                        <div className="flex justify-content-between mb-2">
                            <span className="text-600">Total Amount:</span>
                            <span className="font-bold text-green-600">₹{orderSuccess.amount.toFixed(2)}</span>
                        </div>
                        {!isSelfPickup && (
                            <div className="flex justify-content-between">
                                <span className="text-600">Est. Delivery:</span>
                                <span className="font-bold">{Helpers.formatDateWithShortMonthSpaced(orderSuccess.deliveryDate)}</span>
                            </div>
                        )}
                    </div>

                    <div className="w-full">
                        <Button label="Back to Home" className="w-full p-button-success" style={{ borderRadius: '2rem' }}
                            onClick={() => {
                                setOrderSuccess(prev => ({ ...prev, visible: false }));
                                resetState();
                            }} />
                        <Button label="View Order Details" icon="pi pi-copy" className="w-full mt-2 p-button-success" style={{ borderRadius: '2rem' }} onClick={() => {
                            handleViewOrderDetail(Number(orderSuccess.orderId));
                        }} />
                    </div>
                </div>
            </Dialog>

            {/* Barcode / QR / Batch code scanner dialog */}
            {renderScannerDialog()}

            {/* Multi-product picker when batch code maps to multiple products */}
            {renderScanPickerDialog()}

            {/* Add New Customer Dialog */}
            <Dialog
                header="Add New Customer"
                visible={viewMode === 'ADD_USER' || showAddUserForm}
                onHide={() => {
                    setViewMode('CATALOG');
                    setShowAddUserForm(false);
                }}
                style={{ width: '95vw', maxWidth: '500px' }}
                breakpoints={{ '960px': '75vw', '641px': '95vw' }}
                modal
            >
                <SalesOrderingCustomer
                    visible={true}
                    onHide={() => {
                        setViewMode('CATALOG');
                        setShowAddUserForm(false);
                    }}
                    onCustomerCreated={(userId, name, mobile) => {
                        setCreatedUserId(userId);
                        setSelectedUserId(userId);
                        setSelectedUser({ userId, name, mobile });
                        setViewMode('CATALOG');
                        setShowAddUserForm(false);

                        // Prompt to add address for new customer
                        setShowAddressConfirmDialog(true);
                    }}
                    onAddAddress={() => {
                        setShowAddAddressForm(true);
                    }}
                    toast={toast}
                />
            </Dialog>

            {detailsOrder && (
                <Dialog
                    header="Order Details"
                    visible={visibleOrderDetail}
                    className="mobile-full-width-dialog"
                    style={{ width: "70vw", maxWidth: "1000px" }}
                    breakpoints={{ '960px': '85vw', '641px': '98vw' }}
                    onHide={() => setVisibleOrderDetail(false)}
                    modal
                >
                    <TabView>
                        <TabPanel header="Order Details" leftIcon="pi pi-file mr-1">
                            <NewOrderReview
                                TriggerPrint={() => { }}
                                PrintEnabled={false}
                                OrderData={<OrderPrint orderinfo={detailsOrder} />}
                            />
                        </TabPanel>
                        <TabPanel header="Order Print" leftIcon="pi pi-print mr-1">
                            <OrderPrint orderinfo={detailsOrder} />
                        </TabPanel>
                    </TabView>
                </Dialog>
            )}

            <Suspense fallback={null}>
                <PaymentConfirmDialog
                    showConfirmDialog={isConfirmDialog}
                    hideConfirmDialog={(isSuccess: boolean) => {
                        setIsConfirmDialog(false);
                        if (isSuccess) {
                            setCart(new Map());
                            setCheckoutOpen(false);
                            setCheckoutStep('CART_DELIVERY');
                            setSelectedAddress(null);
                            setSelectedUserId(null);
                            setSelectedUser(null);
                            onHide();
                        }
                    }}
                    orderId={orderIdNum}
                    PlutusTransactionReferenceId={plutusRefId}
                    // orderDetails={{
                    //     address: selectedAddress ? {
                    //         address1: selectedAddress.addressLine1 || '',
                    //         address2: selectedAddress.addressLine2 || '',
                    //         cityName: selectedAddress.city || '',
                    //         stateName: selectedAddress.state || '',
                    //         zipcode: selectedAddress.pincode || '',
                    //     } : null
                    // }}
                    orderDetails={isSelfPickup ? {
                        address: {
                            address1: selectedUser?.name ?? '',
                            address2: selectedUser?.mobile ?? '',
                            landmark: 'Self Pickup',
                            cityName: '',
                            stateName: '',
                            zipcode: ''
                        }
                    } : selectedAddress ? {
                        address: {
                            address1: selectedAddress.addressLine1 ?? '',
                            address2: selectedAddress.addressLine2 ?? '',
                            landmark: '',
                            cityName: selectedAddress.city ?? '',
                            stateName: selectedAddress.state ?? '',
                            zipcode: selectedAddress.pincode ?? ''
                        }
                    } : undefined}
                    amount={totals.total}
                    paymentModeType={selectedPaymentObj?.mode}
                />
                <UserSwipeMachineDialog
                    visible={showMachineDialog}
                    onHide={() => setShowMachineDialog(false)}
                />
            </Suspense>

            {/* Quick View Dialog */}
            {quickViewProduct && (
                <ProductQuickView
                    productData={salesProduct(quickViewProduct, deliveryStock.data)}
                    showQuickViewDialog={quickViewVisible}
                    hideQuickViewDialog={() => {
                        setQuickViewVisible(false);
                        setQuickViewProduct(null);
                    }}
                    addToCartDialog={(qty: number) => {
                        handleBuyNowItemDialog(quickViewProduct, qty);
                        setQuickViewVisible(false);
                        setQuickViewProduct(null);
                    }}
                    minQuantity={quickViewProduct.minOrderQty || 1}
                />
            )}

        </Dialog>
    );
};

export default SalesOrderingDialog;
